import type { SVGProps } from "react";
export default function SvgPptx(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			id="svg4401"
			width="1em"
			height="1em"
			viewBox="0 0 172.02174 156.45262"
			{...props}
		>
			<defs id="defs4398">
				<linearGradient id="linearGradient11849">
					<stop
						id="stop11845"
						offset={0}
						style={{
							stopColor: "#d04223",
							stopOpacity: 1,
						}}
					/>
					<stop
						id="stop11847"
						offset={1}
						style={{
							stopColor: "#d44a27",
							stopOpacity: 1,
						}}
					/>
				</linearGradient>
				<linearGradient
					xlinkHref="#linearGradient11849"
					id="linearGradient17477"
					x1={110.82898}
					x2={110.82898}
					y1={729.64789}
					y2={596.07373}
					gradientTransform="matrix(0 -.70582 .70582 0 -492.157 131.62)"
					gradientUnits="userSpaceOnUse"
				/>
			</defs>
			<g id="layer1" transform="translate(71.437 24.832)">
				<g
					id="shape307-43"
					style={{
						stroke: "none",
						fill: "#fff",
						fillOpacity: 1,
					}}
					transform="matrix(.70582 0 0 .70582 1.019 -406.663)"
				>
					<rect
						id="rect165"
						width={138.075}
						height={159.75}
						x={0}
						y={569.896}
						className="st1"
						style={{
							fill: "#fff",
							stroke: "none",
							strokeWidth: 0.25,
							fillOpacity: 1,
						}}
					/>
				</g>
				<g
					id="shape48-45"
					style={{
						stroke: "none",
						fill: "#d24625",
						fillOpacity: 1,
					}}
					transform="matrix(.70582 0 0 .70582 -8.317 -403.765)"
				>
					<path
						id="path170"
						d="M9.48 560.69c-5.25 0-9.48 3.99-9.48 8.96v151.04c0 4.96 4.23 8.96 9.48 8.96h135.33c5.25 0 9.48-4 9.48-8.96V569.65c0-4.97-4.23-8.96-9.48-8.96zm-1.65 7.94h138.63v152.89l-139.17.18.29-153.59Z"
						className="st6"
						style={{
							fill: "#d24625",
							stroke: "none",
							strokeWidth: 0.683161,
							strokeLinecap: "round",
							strokeLinejoin: "round",
							fillOpacity: 1,
						}}
					/>
				</g>
				<g
					id="shape54-47"
					style={{
						stroke: "none",
						fill: "#d24625",
						fillOpacity: 1,
					}}
					transform="matrix(.70582 0 0 .70582 5.894 -439.183)"
				>
					<rect
						id="rect175"
						width={97.416397}
						height={10.1084}
						x={0}
						y={719.53802}
						className="st7"
						style={{
							fill: "#d24625",
							stroke: "none",
							strokeWidth: 0.25,
							fillOpacity: 1,
						}}
					/>
				</g>
				<g
					id="shape55-49"
					style={{
						stroke: "none",
						fill: "#d24625",
						fillOpacity: 1,
					}}
					transform="matrix(.70582 0 0 .70582 5.894 -422.366)"
				>
					<rect
						id="rect180"
						width={97.416397}
						height={10.1084}
						x={0}
						y={719.53802}
						className="st7"
						style={{
							fill: "#d24625",
							stroke: "none",
							strokeWidth: 0.25,
							fillOpacity: 1,
						}}
					/>
				</g>
				<g
					id="group60-51"
					style={{
						stroke: "none",
						fill: "#d24625",
						fillOpacity: 1,
					}}
					transform="matrix(.70582 0 0 .70582 17.622 -455.715)"
				>
					<g
						id="shape58-52"
						style={{
							stroke: "none",
							fill: "#d24625",
							fillOpacity: 1,
						}}
						transform="translate(4.642 -4.087)"
					>
						<path
							id="path187"
							d="M32.66 696.99h32.66a32.66 32.66-180 0 0-32.66-32.66Z"
							className="st7"
							style={{
								fill: "#d24625",
								stroke: "none",
								strokeWidth: 0.25,
								fillOpacity: 1,
							}}
						/>
					</g>
					<g
						id="shape59-54"
						style={{
							stroke: "none",
							fill: "#d24625",
							fillOpacity: 1,
						}}
					>
						<path
							id="path192"
							d="M32.66 696.99v-32.66a32.659 32.659-180 1 0 32.66 32.66z"
							className="st7"
							style={{
								fill: "#d24625",
								stroke: "none",
								strokeWidth: 0.25,
								fillOpacity: 1,
							}}
						/>
					</g>
				</g>
				<path
					id="path439"
					d="M22.847 131.62V-24.831L-71.437-9.19v125.164Z"
					className="st25"
					style={{
						fill: "url(#linearGradient17477)",
						fillOpacity: 1,
						stroke: "none",
						strokeWidth: 0.176456,
					}}
				/>
				<g
					id="shape277-234"
					style={{
						fill: "#fff",
						fillOpacity: 1,
						stroke: "none",
					}}
					transform="matrix(.70582 0 0 .70582 -40.293 -434.482)"
				>
					<path
						id="path595"
						d="M0 728.82v-74.27l25.71-1.43c8.321-.268 12.2 2.554 16.04 8.044 3.35 4.8 4.35 11.706 3.83 17.746-1.11 12.76-9 23.78-20.87 24.38H13.88v-13.718h7.22c5.175-.229 9.055-5.871 8.807-11.731-.223-6.61-3.698-10.53-8.401-10.696l-7.626.045.01 62.46z"
						className="st24"
						style={{
							fill: "#fff",
							fillOpacity: 1,
							stroke: "none",
							strokeWidth: 0.75,
						}}
					/>
				</g>
			</g>
		</svg>
	);
}
